import React, { useEffect, useState } from "react";
import { Button } from "antd";

import * as serviceWorker from "../../serviceWorker";

const SwReload = () => {
  const [show, setShow] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  const onSWUpdate = (registration) => {
    setShow(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    serviceWorker.unregister();
    // serviceWorker && serviceWorker.register({ onUpdate: onSWUpdate });
  }, []);

  const reloadPage = () => {
    waitingWorker && waitingWorker.postMessage({ type: "SKIP_WAITING" });
    setShow(false);
    window.location.reload();
  };

  return show ? (
    <div className='sw-reload'>
      <h4>Dostępna aktualizacja</h4>
      <div className='buttons-wrapper'>
        <Button onClick={() => setShow(false)} htmlType='button' type='text'>
          anuluj
        </Button>
        <Button htmlType='button' onClick={reloadPage}>
          aktualizuj
        </Button>
      </div>
    </div>
  ) : null;
};

export default SwReload;



// WEBPACK FOOTER //
// ./src/js/components/sw-reload/index.js